import AddNew from "./AddNew";
import Vendors from "./Vendors";

export default { AddNew, Vendors };



// WEBPACK FOOTER //
// ./src/components/vendor/index.js